import type { IPagination } from 'BreetHelpers';

export interface PaginationProps extends Omit<IPagination, 'pageLimit'> {
	onPageChange?: (state: Partial<IPagination>) => void;
	className?: string;
	isLoading?: boolean;
	pageLimit?: number;
	docItemsIdentifier?: string;
}

export interface IPageLimitList {
	pageLimit: number;
	onLimitChange: (limit: number) => void;
	isLoading?: boolean;
}

export const pageLimitOptions = [10, 25, 50, 100, 200];

export interface IPaginationShort {
	currentPage: number;
	pageLimit: number;
	totalDocItems: number;
	isLoading?: boolean;
	onPageChange?: (state: Partial<IPagination>) => void;
}
